import { createFormField } from '@ibsys/kit';
import { KmAttrValueInput } from './KmAttrValueInput';

/** Ввод значения атрибута как поле формы: значение и ошибка берутся у неё. */
export const KmAttrValueField = createFormField(KmAttrValueInput);
